import { useAppStore, type View } from '../store/useAppStore.js';

const PATH_TO_VIEW: Record<string, View> = {
  '/login': 'login-only',
  '/register-learner': 'register-learner',
  '/register-guide': 'register-guide',
  '/profile': 'profile',
};
const VIEW_TO_PATH: Partial<Record<View, string>> = {
  // '/' so returning to the lobby clears a deep-linked path (e.g. /profile)
  // from the address bar. PATH_TO_VIEW deliberately has no '/' entry — the
  // root URL falls through to normal post-bootstrap routing.
  'lobby': '/',
  'login-only': '/login',
  'register-learner': '/register-learner',
  'register-guide': '/register-guide',
  'profile': '/profile',
};

export function viewForPath(pathname: string): View | null {
  return PATH_TO_VIEW[pathname.replace(/\/+$/, '') || '/'] ?? null;
}
export function pathForView(view: View): string | null {
  return VIEW_TO_PATH[view] ?? null;
}
/** Set the store view and reflect it in the address bar. */
export function navigateToView(view: View): void {
  useAppStore.getState().setView(view);
  const path = pathForView(view);
  if (path && window.location.pathname !== path) window.history.pushState({}, '', path);
}
